export default {
    Tous: 'Tous',
    sci_marketview_sale: 'Taq Auto - Vente',
    sci_marketview_service: 'Taq Auto - Service',
    easydeal: 'Easy Deal',
    easy_deal: 'Easy Deal',
    activix: 'Activix',
    autopropulsion: 'Autopropulsion',
    quicktrade: 'Torque',
    vauto: 'vAuto',
    gmcanada: 'GM Canada',
    lucy: 'Lucy',
    mbca_digital: 'Mercedes Canada',
    fca_digital: 'Fiat Chrysler Canada',
    porsche_digital: 'Porsche Canada',
    polaris_digital: 'Polaris Canada',
    kia_digital: 'Kia Canada',
    harleyDavidsonDigital: 'Harley Davidson Canada',
    harley_davidson_digital: 'Harley Davidson Canada',
    nci_digital: 'Nissan-Infiniti Canada',
    nissan_digital: 'Nissan-Infiniti Canada',
    cdk_service_appt: 'CDK - Service',
    cdk_rv_service: 'CDK - Service',
    one_eighty: '1-80',
    serti_service: 'Serti - Service',
    serti_rv_service: 'Serti - Service',
    ctwizard: 'CTWizard',
    ct_wizard: 'CTWizard',
    forddirect: 'Ford Canada',
    ford_direct: 'Ford Canada',
    deskit: 'Deskit',
    scraper: 'Intégrateur',
    serti_vente: 'Serti - Vente',
    serti_sale: 'Serti - Vente',
    stellantis_digital: 'Stellantis Digital',
    jaguar_land_rover_digital: 'Jaguar Land Rover Digital',
    dealer_vu: 'DealerVu',
    pbs: 'PBS',
    pbsService: 'PBS - Service',
    pbs_service: 'PBS - Service',
    pbsWorkOrder: 'PBS - Work Order',
    pbs_work_order: 'PBS - Work Oder',
    maserati_digital: 'Maserati Digital',
    one_eighty_inventory: 'One-Eighty - Inventaire',
    cdk_inventory: 'CDK - Inventaire',
    serti_inventory: 'Serti - Inventaire',
    pbs_inventory: 'PBS - Inventaire',
    easydeal_inventory: 'EasyDeal - Inventaire',
    merlin: 'Merlin',
    serti_renewal: 'Serti - Renouvellement',
    bmwCanada: 'BMW Canada',
    fni_prestige: 'FNI Prestige',
    stellantisDigital: 'Stellantis Digital',
    jaguarLandRoverDigital: 'Jaguar Land Rover Digital',
    ringcentral: 'RingCentral',
    vbdc: 'VBDC',

    cdkCustomer: 'CDK - Customer',
    cdkRvService: 'CDK - Service',
    dealerVu: 'DealerVu',
    fcaDigital: 'Fiat Chrysler Canada',
    kiaDigital: 'Kia Canada',
    mbcaDigital: 'Mercedes Canada',
    nciDigital: 'Nissan-Infiniti Canada',
    oneEighty: 'One-Eighty',
    polestar: 'Polestar',
    porscheDigital: 'Porsche Canada',
    polarisDigital: 'Polaris',
    sciMarketviewSale: 'Taq Auto - Sale',
    sciMarketviewService: 'Taq Auto - Service',
    sertiRvService: 'Serti - Service',
    sertiVente: 'Serti - Sale',
    bmw_canada: 'BMW Canada',
    sertiRenewal: 'Serti - Renouvellement',
    fniPrestige: 'FNI Prestige',
    maseratiDigital: 'Maserati Digital',
    oneEightyInventory: 'One-Eighty - Inventaire',
    cdkInventory: 'CDK - Inventaire',
    sertiInventory: 'Serti - Inventaire',
    pbsInventory: 'PBS - Inventaire',
    easydealInventory: 'EasyDeal - Inventaire',
    mitsubishi: 'Mitsubishi',
    hyundai: 'Hyundai',
    deskitInventory: 'Deskit - Inventaire',
    deskit_inventory: 'Deskit - Inventaire',
    oneSourceInventory: 'One Source - Inventaire',
    onesourceInventory: 'One Source - Inventaire',
    one_source_inventory: 'One Source - Inventaire',
    lautopak_inventory: 'Lautopak - Inventaire',
    lautopakInventory: 'Lautopak - Inventaire',
    autoverify_inventory: 'Auto Verify - Inventaire',
    autoverifyInventory: 'Auto Verify - Inventaire',
    volkswagen: 'Volkswagen',
    audi_canada: 'Audi Canada',
    audiCanada: 'Audi Canada',
    ncar: 'NCAR',
    homenet_inventory: 'HomeNet - Inventaire',
    homenetInventory: 'HomeNet - Inventaire',
    tekion_inventory: 'Tekion - Inventory',
    tekionInventory: 'Tekion - Inventory',
    vauto_inventory: 'vAuto - Inventaire',
    vautoInventory: 'vAuto - Inventaire',
    dealer_vu_inventory: 'DealerVu - Inventaire',
    dealerVuInventory: 'DealerVu - Inventaire',

    hondaCanada: 'Honda Canada',
    acuraCanada: 'Acura Canada',
    honda_canada: 'Honda Canada',
    acura_canada: 'Acura Canada',
    cdkDrive: 'CDK Drive',
    cdk_drive: 'CDK Drive',
    canadianBlackBook: 'Canadian Black Book',
    autovance: 'AutoVance',
    tekion: 'Tekion',
    autosync: 'AutoSync',
    bombardier_recreational_products: 'Bombardier Recreational Products',
    canadian_black_book: 'Canadian Black Book',
    lautopak: 'Lautopak',
    torque_management: 'Torque Management',
    cielocom: 'Cielocom',
    icar: 'ICAR',
    onesource_inventory: 'One Source - Inventaire',
    reynolds_sale: 'Reynolds - Vente',
    reynoldsSale: 'Reynolds - Vente',
    reynolds_inventory: 'Reynolds - Inventaire',
    reynoldsInventory: 'Reynolds - Inventaire',
    reynolds_service: 'Reynolds - Service',
    reynoldsService: 'Reynolds - Service',
    volvo: 'Volvo',
    subaru: 'Subaru',

    export: {
        autovance: 'AutoVance',
        deskit: 'Deskit',
        lucy: 'Lucy',
        oneEighty: 'One-Eighty',
        sertiVente: 'Merlin',
        merlin: 'Merlin',
        pbs: 'PBS',
        autopropulsion: 'Autopropulsion',
        quicktrade: 'Torque',
        vauto: 'vAuto',
        fniPrestige: 'FNI Prestige',
        cdkDrive: 'CDK Drive',
        cdk_drive: 'CDK Drive',
        hyundai: 'VIN',
        volkswagen: 'VIN',
        audi_canada: 'VIN',
        audiCanada: 'VIN',
        tekion: 'Tekion',
        reynoldsSale: 'Reynolds',
        reynolds_sale: 'Reynolds',
    },

    validation: {
        missingPhone: 'Numéro de téléphone valide requis.',
        missingEmail: 'Adresse courriel valide requise.',
        missingNames: 'Prénom et nom requis.',
        missingLastName: 'Nom de famille requis.',
        missingPhones: 'Un numéro de téléphone est requis.',
        missingPostalCode: 'Code Postal requis.',
        missingWantedVehicleYMM:
            'Le lead doit avoir un véhicule recherché avec année/marque/modèle.',
        missingDealType: 'Type de transaction est requis.',
        missingLender: 'Prêteur est requis.',
        missingDealStatus: 'Statut de la transaction est requis.',
        missingModality: 'La modalité est requise.',
        missingFrequency: 'La Fréquence de paiement est requise.',
        missingTerm: 'Le terme est requis.',
    },

    tooltip: {
        doubleSubmit: 'Une seule soumission est autorisée',
        mandatory:
            "Vous devez spécifier la marque, le modèle, l'année et le NIV afin de soumettre le véhicule",
        mandatoryOnlyVin: 'Vous devez spécifier le NIV afin de soumettre le véhicule',
        mandatoryWithOdometer:
            "Vous devez spécifier la marque, le modèle, l'année, l'odomètre et le NIV afin de soumettre le véhicule",
        received: 'Évaluation effectuée par {0} le {1}',
        valuesCannotBeNegatives: 'La valeur et le profit ne peuvent pas avoir une valeur négative.',
        validVin: 'NIV invalide. Un NIV valide est composé de 17 caractères.',
        pbsLastNameRequired: 'Le lead doit avoir un nom complet.',
        pbsBusinessNameRequired: 'Les leads de compagnie doivent avoir un nom de compagnie',
        sertiUserRequired: "Le lead doit avoir un conseiller d'assigné.",
        cdkDriveExportDisabled:
            'Le lead doit avoir un nom, prénom, un numéro de téléphone et un courriel valide et une addresse complete (incluant ville, province, pays et code postal)',
        leadNotFrom: 'Le lead doit provenir de {name}',
        leadAlreadyExported: 'Le lead a déjà été envoyé à {name}',
    },

    label: {
        unsubmitted: 'Non soumis',
        waiting: 'Évaluation soumise le {0}, en attente...',
        received: 'Évaluation reçue',
    },
};
